import React from 'react';
import { Plus, Trash2 } from 'lucide-react';

interface IshikawaRootCauseSectionProps {
    identifiedRootCauses: string[];
    addRootCause: () => void;
    updateRootCause: (index: number, value: string) => void;
    removeRootCause: (index: number) => void;
}

export const IshikawaRootCauseSection: React.FC<IshikawaRootCauseSectionProps> = ({
    identifiedRootCauses,
    addRootCause,
    updateRootCause,
    removeRootCause
}) => {
    return (
        <div className="bg-white rounded-xl border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-semibold text-gray-900">Identified Root Causes</h2>
                <button
                    onClick={addRootCause}
                    className="flex items-center gap-2 px-3 py-1 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                    <Plus className="w-4 h-4" />
                    Add Root Cause
                </button>
            </div>

            {identifiedRootCauses.length === 0 ? (
                <p className="text-gray-500 text-center py-8">
                    After analyzing all categories, identify the true root causes here
                </p>
            ) : (
                <div className="space-y-3">
                    {identifiedRootCauses.map((rootCause, index) => (
                        <div key={index} className="flex gap-2">
                            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-red-100 text-red-700 font-semibold text-sm flex-shrink-0 mt-1">
                                {index + 1}
                            </div>
                            <textarea
                                value={rootCause}
                                onChange={(e) => updateRootCause(index, e.target.value)}
                                rows={2}
                                className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="Describe the root cause..."
                            />
                            <button
                                onClick={() => removeRootCause(index)}
                                className="px-3 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                            >
                                <Trash2 className="w-4 h-4" />
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
